import securityPendingDictionary from '@src/features/registration/security-check/i18n/ru/security-pending.dic.json';

export const securityPending = {
  REGISTRATION_SECURITY_CHECK: securityPendingDictionary,
};

export const securityPendingNamespaces = Object.keys(securityPending);
